export enum InquiryStatus {
  Created = 'Created',
  Ordered = 'Ordered',
}
